var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 5C13.953 5 4.99988 13.9531 4.99988 25C4.99988 36.0469 13.953 45 24.9999 45C36.0468 45 44.9999 36.0469 44.9999 25C44.9999 13.9531 36.0468 5 24.9999 5Z",
    fill: "url(#paint0_linear_1020_12887)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1072 30.061H33.359L34.1833 24.7143H28.1072V21.7922C28.1072 19.5741 28.8311 17.6049 30.9022 17.6049H34.2308V12.9411C33.6496 12.8617 32.408 12.6923 30.0727 12.6923C25.1907 12.6923 22.3271 15.2756 22.3271 21.1622V24.7143H17.3077V30.061H22.3271V44.7511C23.3204 44.8994 24.3242 45 25.3598 45C26.295 45 27.2038 44.9153 28.1072 44.7935V30.061Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1020_12887",
    x1: 10.9928,
    y1: 10.9929,
    x2: 41.6151,
    y2: 41.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c9f9b2f1aef760cd1f33048bff151f2e.svg";
export { ForwardRef as ReactComponent };